import { IoIosBuild } from "react-icons/io";
import { BACKEND_URI } from "./entries";


export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/
    );
};


export const validatePassword = (password) => {
  const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-.,]).{8,}$/
  return pattern.test(password)
}


export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();

  return `${hours}:${minutes} ${day}.${month}.${year}`;
}


export function timePassedChat(timestamp, t) {
  const date = new Date(timestamp); // Convert Unix timestamp to milliseconds
  const now = new Date();

  const sameDay = date.toDateString() === now.toDateString();
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  if (sameDay) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else if (date.toDateString() === yesterday.toDateString()) {
    return t("Yesterday");
  } else {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  }
}


export function timePassed(timestamp, t) {

  // t is the i18next useTranslation import. It must be from 'common' namespace

  const now = new Date();
  const past = new Date(timestamp);
  const diffInSeconds = Math.floor((now - past) / 1000);
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  const diffInHours = Math.floor(diffInMinutes / 60);

  if (diffInSeconds < 10) {
    return t("time.now")
  }

  if (diffInSeconds < 60) {
    return t(diffInSeconds === 1 ? 'time.second_ago' : 'time.seconds_ago', { count: diffInSeconds });
  }

  if (diffInMinutes < 60) {
    return t(diffInMinutes === 1 ? 'time.minute_ago' : 'time.minutes_ago', { count: diffInMinutes });
  }

  if (diffInHours < 24) {
    return t(diffInHours === 1 ? 'time.hour_ago' : 'time.hours_ago', { count: diffInHours });
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    return t(diffInDays === 1 ? 'time.day_ago' : 'time.days_ago', { count: diffInDays });
  }

  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) {
    return t(diffInMonths === 1 ? 'time.month_ago' : 'time.months_ago', { count: diffInMonths });
  }

  const diffInYears = Math.floor(diffInMonths / 12);
  return t(diffInYears === 1 ? 'time.year_ago' : 'time.years_ago', { count: diffInYears });
}



export function isWithinTimeRange(startHour, endHour) {
  // Get the current time in UTC
  const now = new Date();

  // Get the current time in GMT+3 (convert from UTC)
  const offsetInHours = 3;
  const currentHour = now.getUTCHours() + offsetInHours;
  const currentMinutes = now.getUTCMinutes();

  // Adjust for potential day wraparound (i.e., hours beyond 24)
  const adjustedHour = (currentHour >= 24) ? currentHour - 24 : currentHour;

  // Define the time range (10:00 - 19:00 GMT+3)

  // Check if the current time is within the time range
  if (adjustedHour > startHour && adjustedHour < endHour) {
    return true;
  } else if (adjustedHour === startHour && currentMinutes >= 0) {
    return true; // Include exactly 10:00
  } else if (adjustedHour === endHour && currentMinutes === 0) {
    return true; // Include exactly 19:00
  }

  return false;
}


export function IsoFormatToCustom(time) {

  time = time.split("T")
  let date = time[0]
  time = time[1].split(":")
  time = time[0] + ":" + time[1]

  date = date.split("-")
  date = date[2] + "." + date[1] + "." + date[0]

  return time + " " + date
}


export const TryMeButton = ({ callback }) => {


  if (!callback) {
    return <></>
  }

  return (
    <div className="absolute z-[1000]">
      <div className="relative">

        <button
          className="absolute top-5 left-[1000px] btn btn-md rounded-lg bg-red-600 hover:bg-red-800 text-white"
          onClick={callback}
        >Try Me</button>
      </div>
    </div>
  )
}



export const UnderConstruction = () => {


  return (
    <div className="w-full h-96  flex flex-col justify-center items-center gap-2">
      <div className="-translate-x-2">
        <IoIosBuild
          className="wave-animation origin-top-right"
          size={25}
        />
      </div>
      <h1 className="text-lg">Under construction</h1>
    </div>
  )
}


export const eqSet = (xs, ys) => {
  return xs.size === ys.size && [...xs].every((x) => ys.has(x))
}


export function capitalizeFirstLetter(val) {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}


export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};


export const setImageUrl = (url) => {
  return BACKEND_URI + "/" + url
}


function whoIsYourDaddy() {
    console.info('This project was built by noodlewcoke for Mobile2 Global, VEND Software.')
    console.info('Project version:', process.env.REACT_APP_I18N_VERSION)
    return ""
}

window.whoIsYourDaddy = whoIsYourDaddy;